export default __webpack_public_path__ + "static/media/david-fields@2x.28e5bc67.png";